import { authenticatedAjax, REQUEST } from "src/co/sura/config/ajax-wrapper";
import { AnyAction } from "redux";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import { FiltroEmpresas, DatosEmpresaTraslado } from "../modelo/EmpresasTrasladadas";
import { obtenerEstadoPoliza } from "../modelo/EstadoPoliza";
import { obtenerTipoReporte } from "../modelo/TipoReporte";
import {
    CONSULTAR_EMPRESAS_SAT,
    ERROR_CONTROLADO_CONSULTA,
    ERROR_DESCONOCIDO_CONSULTA,
    RESPUESTA_EMPRESAS_TRASLADADA,
    DESCARGAR_XLS_EMPRESAS,
    XLS_REPORTE_EMPRESAS_CREADO,
    LIMPIAR_MENSAJES_EMPRESAS,
    empresasSATConsultadas,
    errorDesconocidoConsulta,
    errorControladoConsulta,
    xlsReporteEmpresasCreado
} from "./empresasTrasladadasActions";
import {
    cabeceraReporteEmpresasSAT,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";
import fileDownload from "js-file-download";
import * as moment from "moment";

export const consultarEmpresaSATEpic = action$ =>
    action$.ofType(CONSULTAR_EMPRESAS_SAT)
        .mergeMap((action: any) => {

            const url = `sat/consultar/empresas-trasladadas?${obtenerFiltroEmpresas(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    return respuestaEmpresas(respuesta);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorDesconocidoConsulta()];
                });
        });

export const descargarXLSEmpresasEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_EMPRESAS)
        .mergeMap((action: any) => {

            const empresas = action.datosEmpresas;
            const excelBlob: Blob = construirXLS(empresas);
            const nombreArchivo = `reporte_empresas_sat_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
            fileDownload(
                excelBlob,
                nombreArchivo,
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
            return [xlsReporteEmpresasCreado()];

        });

export const empresasTrasladadasReducer = (state = {
    estadoConsulta: REQUEST.NONE,
    mensajeUsuario: undefined,
    datosEmpresas: undefined,
    error: undefined,
    consecutivoProceso: 0,
    paginas: 0,
    totalEmpresasConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_EMPRESAS_SAT:
            return {
                ...state,
                estadoConsulta: REQUEST.PENDING,
                mensajeUsuario: undefined,
                datosEmpresas: undefined,
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalEmpresasConsulta: 0,
                paginaActual: action.filtro.paginaActual,
            };
        case RESPUESTA_EMPRESAS_TRASLADADA:
            return {
                ...state,
                estadoConsulta: REQUEST.SUCCESS,
                datosEmpresas: action.datosEntidad,
                mensajeUsuario: undefined,
                paginas: action.paginas,
                totalEmpresasConsulta: action.totalDatos,
                consecutivoProceso: action.consecutivoProceso,
                error: action.error
            };
        case ERROR_CONTROLADO_CONSULTA:
            return {
                ...state,
                estadoConsulta: REQUEST.ERROR,
                datosEmpresas: undefined,
                mensajeUsuario: action.mensajeRespuesta,
                paginas: 0,
                totalEmpresasConsulta: 0
            };
        case ERROR_DESCONOCIDO_CONSULTA:
            return {
                ...state,
                estadoConsulta: REQUEST.ERROR,
                datosEmpresas: undefined,
                mensajeUsuario: undefined,
                paginas: 0,
                totalEmpresasConsulta: 0
            };
        case XLS_REPORTE_EMPRESAS_CREADO:
            return {
                ...state
            };
        case LIMPIAR_MENSAJES_EMPRESAS:
            return {
                ...state,
                estadoConsulta: REQUEST.NONE,
                mensajeUsuario: undefined,
                datosEmpresas: undefined,
                paginas: 0,
                totalEmpresasConsulta: 0,
                tamanoPagina: 10,
                paginaActual: 0
            };
        default:
            return state;
    }
};

const obtenerFiltroEmpresas = (filtro: FiltroEmpresas) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.consecutivoConsulta) params.set('consecutivoConsulta', filtro.consecutivoConsulta.toString());
        if (filtro.fechaInicial) params.set('fechaInicio', filtro.fechaInicial);
        if (filtro.fechaFinal) params.set('fechaFin', filtro.fechaFinal);
        if (filtro.usuario)  params.set('usuario', filtro.usuario);
    }

    return params.toString();
};

const respuestaEmpresas = (respuesta: any) => {
    if (respuesta.solicitudExito) {
        const datos = respuesta.datos;
        return empresasSATConsultadas(datos.datosEntidad, datos.paginas, datos.totalDatos, datos.consecutivoProceso, datos.error);
    }
    return errorControladoConsulta(respuesta.mensajeRespuesta);
};

const construirXLS = (datos: Array<DatosEmpresaTraslado>) => {
    if (!datos || !datos.length)
        return;
    /*Libros a generar en el XLS*/
    const libro = 'Reporte Empresas SAT';
    const librosXLS = [libro];

    const datosEmpresas = [];

    const validarVacio = (dato: any) => {
        return dato ? dato : '';
    };

    datos.forEach(empresa => {
        const empresaSAT = empresa.empresaSAT;
        const datosPoliza = empresa.datosPoliza;

        datosEmpresas.push([
            { value: validarVacio(empresaSAT.tipoDocumentoEmpleador) },
            { value: validarVacio(empresaSAT.numeroDocumentoEmpleador) },
            { value: validarVacio(empresaSAT.consecutivoNitDescentralizado) },
            { value: validarVacio(empresaSAT.fechaSolicitud) },
            { value: validarVacio(empresaSAT.fechaFinAfiliacion) },
            { value: validarVacio(obtenerTipoReporte(empresaSAT.tipoReporte).descripcion) },
            { value: validarVacio(datosPoliza.poliza) },
            { value: validarVacio(datosPoliza.dniEmpleador) },
            { value: validarVacio(datosPoliza.fechaAlta) },
            { value: validarVacio(datosPoliza.fechaBaja) },
            { value: validarVacio(obtenerEstadoPoliza(datosPoliza.codigoEstado).texto) }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libro,
        cabecera: cabeceraReporteEmpresasSAT(),
        datos: datosEmpresas,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/modulos/empresasTrasladadasReducers.ts